import { SelectItem } from "@mantine/core/lib/Select/types";

import { BABABOS_TENANT_ID } from "../constants.ts";
import { RolePermission, UserRole } from "../graphql/generated";
import { CurrentUser, User } from "../types/user.ts";

export const getUserDisplayName = (
  user: User | Pick<User, "id" | "name" | "email"> | undefined | null
): string | null => {
  if (!user) {
    return null;
  }
  return user.name ?? user.email;
};

export const hasPermission = (
  user: CurrentUser | undefined | null,
  permission: RolePermission,
  bababosTenantOnly = false
): boolean => {
  if (bababosTenantOnly && !isBababosTenant(user)) {
    return false;
  }
  return user?.permissions?.includes(permission) ?? false;
};

export const getUserOptions = (
  data: Pick<User, "id" | "email" | "name">[] | null | undefined
): SelectItem[] => {
  return (
    data?.map((user) => ({
      value: String(user.id),
      label: getUserDisplayName(user) ?? "",
    })) ?? []
  );
};

export const isBababosTenant = (user: CurrentUser | undefined | null) => {
  let tenantId = user?.tenantId;
  if (isBababosSuperAdmin(user)) {
    tenantId = Number(localStorage.getItem("tenantId") ?? BABABOS_TENANT_ID);
  }
  return tenantId === BABABOS_TENANT_ID;
};

export const isBababosSuperAdmin = (user: CurrentUser | undefined | null) => {
  return (
    user?.role === UserRole.SuperAdmin && user?.tenantId === BABABOS_TENANT_ID
  );
};
